import { RadioInput, Checkbox } from '@panwds/react-ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTableInstance } from './TableContext.esm.js';

function Cell({ row }) {
    const { rowSelectMode, onRowSelect } = useTableInstance();
    const intl = useIntl();
    const label = row.isSelected
        ? intl.formatMessage({
            defaultMessage: 'Deselect row {number}',
            id: 'agKOkN',
            description: 'Label for deselecting a selected table row'
        }, {
            number: row.index
        })
        : intl.formatMessage({
            defaultMessage: 'Select row {number}',
            id: '93pvB7',
            description: 'Label for selecting a table row'
        }, {
            number: row.index
        });
    const { indeterminate, ...props } = row.getToggleRowSelectedProps({
        title: undefined
    });
    if (rowSelectMode === 'single') {
        return (React.createElement(RadioInput, { "aria-label": label, checked: row.isSelected, ...props, onChange: (event) => { var _a; return onRowSelect ? onRowSelect(row, event.target.checked) : (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event); } }));
    }
    return (React.createElement(Checkbox, { ...props, onChange: (event) => {
            var _a;
            return onRowSelect
                ? onRowSelect(row, event.target.checked)
                : (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
        }, indeterminate: indeterminate, "aria-label": label }));
}
function Header({ isAllRowsSelected, getToggleAllRowsSelectedProps }) {
    const { rowSelectMode, onAllRowSelect, rows, toggleRowSelected } = useTableInstance();
    const intl = useIntl();
    if (rowSelectMode === 'single')
        return null;
    const { indeterminate, ...props } = getToggleAllRowsSelectedProps({
        title: undefined
    });
    return (React.createElement("div", { className: "tw-box-border leading-none" },
        React.createElement(Checkbox, { ...props, checked: isAllRowsSelected, indeterminate: indeterminate, "data-testid": "is-all-rows-selected", onChange: (event) => {
                onAllRowSelect
                    ? onAllRowSelect(event.target.checked)
                    : rows.forEach((row) => {
                        if (row.original['disabled'] && !row.isSelected) {
                            toggleRowSelected(row.id, false);
                        }
                        else if (!indeterminate && !isAllRowsSelected) {
                            toggleRowSelected(row.id, true);
                        }
                        else if (indeterminate) {
                            toggleRowSelected(row.id, false);
                        }
                        else {
                            toggleRowSelected(row.id, false);
                        }
                    });
            }, "aria-label": isAllRowsSelected
                ? intl.formatMessage({
                    defaultMessage: 'Deselect all rows',
                    id: 'GDJaqT',
                    description: 'Label for checkbox to deselect all rows'
                })
                : intl.formatMessage({
                    defaultMessage: 'Select all rows',
                    id: 'lJOsMK',
                    description: 'Label for checkbox that will select all rows'
                }) })));
}
const SelectRowColumn = {
    id: 'select-row',
    Cell,
    disableResizing: true,
    disableExport: true,
    disableGlobalFilter: true,
    disableHideColumn: true,
    disableSortBy: true,
    disableGroupBy: true,
    Header,
    isSelectRowColumn: true,
    sticky: true,
    stickyPosition: 'left',
    width: 50
};
function useInsertSelectRowColumn(hooks) {
    hooks.visibleColumns.push((columns, meta) => {
        if (!meta.instance.disableRowSelect) {
            return [SelectRowColumn, ...columns];
        }
        return columns;
    });
}

export { SelectRowColumn, useInsertSelectRowColumn };
//# sourceMappingURL=SelectRowColumn.esm.js.map
